import { gql } from "@apollo/client";

export const WELLNESS_PLAN_CANCEL_RENEWAL = gql`
mutation cancelWellnessPlanAutoRenewal($petId: String!){
  cancelWellnessPlanAutoRenewal(petId: $petId){
    success
    messages
  }
}
`;
